import type { ReportForList } from '@/types/reports';
import { getReportStatusLabel } from '@/lib/reportStatus';
import type { ReportSort } from '../types';

export { sortReportsByDateDesc } from '@/lib/sortReports';

function compareStrings(a: string, b: string): number {
  return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' });
}

export function sortReports(reports: ReportForList[], sort: ReportSort | null): ReportForList[] {
  if (!sort) return reports;

  const sorted = [...reports].sort((left, right) => {
    if (sort.key === 'title') {
      return compareStrings(left.title, right.title);
    }

    if (sort.key === 'createdAt') {
      return left.createdAt.getTime() - right.createdAt.getTime();
    }

    if (sort.key === 'updatedAt') {
      return (left.updatedAt?.getTime() ?? 0) - (right.updatedAt?.getTime() ?? 0);
    }

    if (sort.key === 'partner_name') {
      return compareStrings(left.partner_name ?? '', right.partner_name ?? '');
    }

    if (sort.key === 'visitor_count') {
      return left.visitor_count - right.visitor_count;
    }

    if (sort.key === 'view_count') {
      return left.view_count - right.view_count;
    }

    return compareStrings(getReportStatusLabel(left.status), getReportStatusLabel(right.status));
  });

  return sort.direction === 'desc' ? sorted.reverse() : sorted;
}

export function nextReportSort(
  current: ReportSort | null,
  key: ReportSort['key']
): ReportSort | null {
  if (current?.key !== key) {
    return { key, direction: 'asc' };
  }

  if (current.direction === 'asc') {
    return { key, direction: 'desc' };
  }

  return null;
}
